import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent implements OnInit {
  multipleMessages: boolean = false;
  link: string | null = null;

  constructor(
    public snackBarRef: MatSnackBarRef<ToasterComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      status: 'INFO' | 'SUCCESS' | 'ERROR' | 'WARNING';
      message: string | string[];
      link: string | null;
      variant?: string;
      variantTitle?: string;
      actionLabel?: string;
      actionCallback?: () => void;
    },
    private router: Router,
  ) {
    if(Array.isArray(data.message)) {
      this.multipleMessages = true
    }
    this.link = data.link;
  }

  ngOnInit(): void {}

  getMessages(): string[] {
    if(Array.isArray(this.data.message)) {
      return this.data.message
    }

    return []
  }

  /** The ERP's own rejection text, shown under a translated title. Its
   *  branch interpolates the message instead of binding [innerHTML], so an ERP
   *  string containing `<...>` is read as text rather than parsed as markup. */
  isErpPushError = () => this.data.variant === 'ERP_PUSH_ERROR';

  alertIcon = () => {
    if (this.data.variant && this.data.variant === 'PROMPT_TO_ORDER_ERROR') {
      return 'red-warning_icon';
    }

    switch (this.data.status) {
      case 'SUCCESS':
        return 'check_circle';
      case 'ERROR':
        return 'cancel';
      case 'WARNING':
        return 'warning_white';
      default:
        return 'info';
    }
  };

  navigateToLink() {
    if (this.link) {
      this.snackBarRef.dismiss();
      this.router.navigateByUrl(this.link);
    }
  }

  variantClass(): string | null {
    if (!this.data.variant) return '';
    return `toast-variant-${this.data.variant}`.toLowerCase().replace(/_/g, '-');
  }

  toastClasses(): { [klass: string]: boolean } {
    const variant = this.variantClass();

    return {
      'notification-container-error': this.data.status === 'ERROR',
      'notification-container-success': this.data.status === 'SUCCESS',
      'notification-container-info': this.data.status === 'INFO',
      'notification-container-warning': this.data.status === 'WARNING',
      ...(variant ? { [variant]: true } : {}),
    };
  }

  closeToast() {
    this.snackBarRef.dismiss();
  }

  onActionClick() {
    if (this.data.actionCallback) {
      this.data.actionCallback();
    }
    this.snackBarRef.dismiss();
  }
}
